import { Component, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { RoleListTableDataService } from '../../services/role-list-tabledata.service';
import { RBACPermissionService } from '../../services/rbac-role.service';
import { BaseListTableComponent } from 'app/core/services/data-services/base-table-list-component';
import { RoleModalComponent } from '../../role-modal/role-modal.component';
import { TemplateConfirmModalComponent } from '../../../../shared/components/template-confirm-modal/template-confirm-modal.component';

@Component({
    selector: 'app-role-list-table',
    templateUrl: './role-list-table.component.html',
    styleUrls: ['./role-list-table.component.css']
})
export class RoleListTableComponent extends BaseListTableComponent<RoleListTableDataService> {

    bsModalRef: BsModalRef;

    canCreate: boolean = true;
    canUpdate: boolean = false;
    canDelete: boolean = false;

    constructor(
        protected _cdr: ChangeDetectorRef,
        protected _rbacPermissionService: RBACPermissionService,
        protected _modalService: BsModalService,
        protected _toastr: ToastrService,
        protected _location: Location
    ) {
        super(_rbacPermissionService, _toastr, _location);
    }

    /* Events */
    /*-----------*/

    onCreateRole() {
        if (!this.canCreate) {
            return;
        }
        const modalTile = 'Create Role';
        this._rbacPermissionService.initRoleActionModel(modalTile, null);

        this.bsModalRef = this._modalService.show(RoleModalComponent, { class: 'modal-lg' });

        this.bsModalRef.content.onDataUpdated.subscribe(() => {
            this.refreshTableData();
        });
    }

    onEditRole(role: any): void {
        if (!this.canUpdate) {
            return;
        }
        const modalTile = 'Update Role';
        const roleToEdit = this._rbacPermissionService.mapTableDataRowToViewModel(role);
        this._rbacPermissionService.initRoleActionModel(modalTile, roleToEdit);

        this.bsModalRef = this._modalService.show(RoleModalComponent, { class: 'modal-lg' });

        this.bsModalRef.content.onDataUpdated.subscribe(() => {
            this.refreshTableData();
        });
    }

    onDeleteRole(role: any) {
        if (!this.canDelete) {
            return;
        }
        if(role['Users@odata.count'] > 0){
            this._toastr.warning(`Please remove users linked to role`);
            return;
        }
        this.bsModalRef = this._modalService.show(TemplateConfirmModalComponent, { class: 'modal-lg' });
        this.bsModalRef.content.title = "Are you sure you want to delete " + role.RoleName + "?";
        this.bsModalRef.content.confirmation = () => {
            this._rbacPermissionService.deleteRole(role.Id).subscribe(
                x => {
                    this._toastr.success(`Role Deleted Successfully`);
                    this.refreshTableData();
                },
                error => {
                    let errorMessage = typeof error === 'string' ? error : 'An unknown error occurred while performing the action';
                    this._toastr.error(errorMessage);
                    this.refreshTableData();
                }
            );
        };
    }

    refreshTableData() {
        this._rbacPermissionService.refreshTableDataInclFilters()
            .subscribe(
                x => {
                },
                error => {
                    this.handleError(error);
                }
            );
    }

    ngOnInit() {
        super.ngOnInit(); // Call the ngOnInit method of the base component

        this._rbacPermissionService.getRBACPermissions().subscribe(x => {
            this.canCreate = x.create;
            this.canUpdate = x.update;
            this.canDelete = x.delete;
        });

    }

    registerTDSEventHandlers(): void {
        this.subscriptions.push(this._rbacPermissionService.subscribeToTDSDataRefreshed(() => {
            console.log(this.tableDataService.identifier + ' data has been refreshed');
            // Handle the refreshTableDataComplete$ event here
        }));

        this.subscriptions.push(this._rbacPermissionService.subscribeToTDSFilterOptionsRefreshed(() => {
            console.log(this.tableDataService.identifier + ' filter options have been loaded');
            // Handle the filterOptionsLoadComplete$ event here
        }));

        this.subscriptions.push(this._rbacPermissionService.subscribeToTDSRefreshAllCompleted(() => {
            console.log(this.tableDataService.identifier + ' filters & data has been refreshed');
            // Handle the refreshAllComplete$ event here
        }));

        this.subscriptions.push(this._rbacPermissionService.subscribeToTDSErrorOccurred(() => {
            console.log(this.tableDataService.identifier + ' an error occurred');
            // Handle the errorOccurred$ event here
        }));
    }

    ngOnDestroy() {
        super.ngOnDestroy(); // Call the ngOnDestroy method of the base component
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
